import React, {useEffect, useRef} from 'react';
import './style.css';
import Event2Listing from '../../CommonComponents/EventListing2.0';
import SponsorListing from '../../CommonComponents/SponsorListing';
import ChapterPageheroText from '../../CommonComponents/ChapterPageHeroText';
import {Col, Row} from 'antd';
import PastEventsListing from '../../CommonComponents/PastEventsListing';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import PbssInMap from '../../CommonComponents/PbssInCommonMap';
import ChapterBannerComponent from '../../CommonComponents/ChapterBannerComponent';
import EventInfoCard from '../../CommonComponents/EventHighlights';
import StandingCommiteeListing from '../../CommonComponents/StandingCommiteeListing';
import CustomCollapse from '../../CommonComponents/CommonAccordian';
import useLocalization from '../../../Localization';
import {LANGUAGES} from '../../../Localization/LanguageContext';

const PbssChapterComponent = ({
  allEventSponsorLogos,
  handleYearFilter,
  pagination,
  totalEventCount,
  handleLoadMore,
  pastEventData,
  handleChapterFilter,
  handleEventTypeFilter,
  filterBydate,
  chaptersList,
  eventTypeList,
  countLoadMoreData,
  filteredEvents,
  selectedEventTypeValue,
  selectedChapterValue,
  selectedDateValue,
  dateToggle,
  dateOrderHandler,
  handlePaginationChange,
  normalizedName,
  totalPastEventsPages,
  selectedYearValue,
  chapterWiseCommitteeData,
  chapterHeading,
  chapterContent,
  chapterFullName,
  otherChapterEventData,
  handleLanguageSwitch,
  heroLinkText,
  japaneseHeroLinkText,
}) => {
  const sectionRef = useRef(null);
  const {ApplicationString, currentLanguage} = useLocalization();

  const collapseData = chapterContent?.sponsorship_info
    ? chapterContent?.sponsorship_info?.map((item) => {
        return {
          title: item.key,
          content: item.value,
        };
      })
    : [];

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const handleScrollToSection = (e) => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({behavior: 'smooth'});
    }
  };

  const getChapterWelcomeLine = (chapter) => {
    switch (chapter) {
      case 'Seattle':
        return {
          message: (
            <>
              {ApplicationString['chapterPage.chapterHeading.welcome']}{' '}
              <label className='chapter-welcomeline'>
                {
                  ApplicationString[
                    'chapterPage.chapterHeading.pbssInternational.seattle'
                  ]
                }
              </label>{' '}
              {ApplicationString['chapterPage.chapterHeading.pbss']} <br />
              {
                ApplicationString[
                  'chapterPage.chapterHeading.pbssInternational'
                ]
              }
            </>
          ),
          chapterTitleName: 'Seattle',
          hideSubheading: false,
        };
      case 'Boston':
        return {
          message: (
            <>
              {ApplicationString['chapterPage.chapterHeading.welcome']}{' '}
              <label className='chapter-welcomeline'>
                {
                  ApplicationString[
                    'chapterPage.chapterHeading.pbssInternational.boston'
                  ]
                }
              </label>{' '}
              {ApplicationString['chapterPage.chapterHeading.pbss']} <br />
              {
                ApplicationString[
                  'chapterPage.chapterHeading.pbssInternational'
                ]
              }
            </>
          ),
          chapterTitleName: 'Boston',
          hideSubheading: false,
        };
      case 'Vancouver':
        return {
          message: (
            <>
              {ApplicationString['chapterPage.chapterHeading.welcome']}{' '}
              <label className='chapter-welcomeline'>
                {
                  ApplicationString[
                    'chapterPage.chapterHeading.pbssInternational.vancouver'
                  ]
                }
              </label>{' '}
              {ApplicationString['chapterPage.chapterHeading.pbss']} <br />
            </>
          ),
          chapterTitleName: 'Vancouver',
          hideSubheading: false,
        };
      case 'Korea':
        return {
          message: (
            <>
              {ApplicationString['chapterPage.chapterHeading.welcome']}{' '}
              <label className='chapter-welcomeline'>
                {
                  ApplicationString[
                    'chapterPage.chapterHeading.pbssInternational.korea'
                  ]
                }
              </label>{' '}
              {ApplicationString['chapterPage.chapterHeading.pbss']} <br />
              {
                ApplicationString[
                  'chapterPage.chapterHeading.pbssInternational'
                ]
              }
            </>
          ),
          chapterTitleName: 'Korea',
          hideSubheading: false,
        };
      case 'Japan':
        return {
          message: (
            <>
              {ApplicationString['chapterPage.chapterHeading.welcome.japan']}{' '}
              <label className='chapter-welcomeline'>
                {
                  ApplicationString[
                    'chapterPage.chapterHeading.pbssInternational.japan'
                  ]
                }
              </label>{' '}
              {ApplicationString['chapterPage.chapterHeading.pbss.japan']}{' '}
              <br />
              {
                ApplicationString[
                  'chapterPage.chapterHeading.pbssInternational.japan'
                ]
              }
            </>
          ),
          chapterTitleName: 'Japan',
          hideSubheading: false,
        };
      default:
        return {
          message: (
            <>
              {ApplicationString['chapterPage.chapterHeading.welcome']}{' '}
              {
                ApplicationString[
                  'chapterPage.chapterHeading.pbssInternational.default'
                ]
              }
              -{' '}
            </>
          ),
          chapterTitleName: '',
          hideSubheading: true, // Set to true to hide the subheading
        };
    }
  };

  const chapterWiseAboutLine = () => {
    if (!chapterTitleName) {
      return `${ApplicationString['mainLayoutComponent.navbar.aboutPbss']} ${chapterFullName} ${ApplicationString['mainLayoutComponent.navbar.aboutPbss.pbss']}`;
    } else {
      if (chapterFullName === 'Japan' && currentLanguage === LANGUAGES.EN) {
        return `About ${chapterTitleName} PBSS`;
      } else if (
        currentLanguage === LANGUAGES.JA &&
        chapterFullName === 'Japan'
      ) {
        return `${chapterTitleName} PBSSについて​`;
      } else {
        return `${ApplicationString['mainLayoutComponent.navbar.aboutPbss']} ${chapterTitleName} ${ApplicationString['mainLayoutComponent.navbar.aboutPbss.pbss']}`;
      }
    }
  };

  const renderBenefits = (benefits) => {
    return (
      <div
        className='perks-inter'
        dangerouslySetInnerHTML={{__html: benefits}}
      />
    );
  };

  const {message, chapterTitleName, hideSubheading} =
    getChapterWelcomeLine(normalizedName);

  return (
    <React.Fragment>
      <Row gutter={[0, 30]} className='pbssMainContainerRowChapter'>
        <Col span={24}>
          <ChapterBannerComponent
            chaptersList={chaptersList}
            pageHeadingComponent={
              <ChapterPageheroText
                heading={message}
                chapterTitleName={chapterTitleName}
                onScroll={handleScrollToSection}
                chapterHide={hideSubheading}
                subheading={hideSubheading ? normalizedName : ''}
                bgColor='#f6f9fc'
                chapterFullName={chapterFullName}
                handleLanguageSwitch={handleLanguageSwitch}
                heroLinkText={heroLinkText}
                japaneseHeroLinkText={japaneseHeroLinkText}
              />
            }
          />
        </Col>
        <Col span={24}>
          <PbssInMap
            mapSize={300}
            chaptersList={chaptersList}
            specialAnnouncementHeading={chapterContent?.special_announcement}
            usedForAdsOnly
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Event2Listing
            filteredEvents={filteredEvents}
            handleChapterFilter={handleChapterFilter}
            handleEventTypeFilter={handleEventTypeFilter}
            filterBydate={filterBydate}
            isChapSelect={true}
            chaptersList={chaptersList}
            eventTypeList={eventTypeList}
            countLoadMoreData={countLoadMoreData}
            totalEventCount={totalEventCount}
            handleLoadMore={handleLoadMore}
            selectedChapterValue={selectedChapterValue}
            selectedEventTypeValue={selectedEventTypeValue}
            selectedDateValue={selectedDateValue}
            dateToggle={dateToggle}
            dateOrderHandler={dateOrderHandler}
            title={`${ApplicationString['chapterPage.eventChapter.title']} ${chapterFullName} ${ApplicationString['chapterPage.eventChapter.title2']}`}
          />
        </Col>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <Event2Listing
            filteredEvents={otherChapterEventData}
            handleChapterFilter={handleChapterFilter}
            countLoadMoreData={countLoadMoreData}
            totalEventCount={totalEventCount}
            handleLoadMore={handleLoadMore}
            selectedChapterValue={selectedChapterValue}
            selectedDateValue={selectedDateValue}
            dateOrderHandler={dateOrderHandler}
            title={ApplicationString['chapterPage.otherChapterEventData.title']}
            isShowFilter={false}
          />
        </Col>
        <Col span={24}>
          <PastEventsListing
            handlePaginationChange={(page, pageSize) => {
              handlePaginationChange(page, pageSize);
            }}
            pastEventData={pastEventData}
            pagination={pagination}
            handleYearFilter={handleYearFilter}
            totalPastEventsPages={totalPastEventsPages}
            selectedYearValue={selectedYearValue}
            usedForBio={true}
          />
        </Col>
        <Col span={24}>
          <EventInfoCard editData={chapterContent} />
        </Col>
        <div ref={sectionRef}></div>

        {chapterContent?.about_chapter && (
          <Col span={24}>
            <SectionLayout>
              <div className='Commitee-listing-heading chapter-margin'>
                <p>{chapterWiseAboutLine()}</p>
              </div>
              <span className='chapter-content-span'>
                {chapterContent?.about_chapter}
              </span>
            </SectionLayout>
          </Col>
        )}

        {chapterContent?.mission && (
          <Col span={24}>
            <SectionLayout>
              <div className='Commitee-listing-sub-heading chapter-margin'>
                <p className='chapter-heading-underline'>
                  {ApplicationString['chapterPage.mission.title']}
                </p>
              </div>
              <span className='chapter-content-span'>
                {chapterContent?.mission}
              </span>
            </SectionLayout>
          </Col>
        )}

        {collapseData?.length > 0 && (
          <Col span={24}>
            <SectionLayout>
              <div className='Commitee-listing-sub-heading chapter-margin'>
                <p className='chapter-heading-underline'>
                  {ApplicationString['chapterPage.sponsorshipDetails.title']}
                </p>
              </div>
              <CustomCollapse data={collapseData} titleHide />
            </SectionLayout>
          </Col>
        )}

        {chapterWiseCommitteeData?.length > 0 && (
          <Col span={24}>
            <SectionLayout>
              <StandingCommiteeListing
                data={chapterWiseCommitteeData}
                heading={chapterHeading}
              />
            </SectionLayout>
          </Col>
        )}

        {chapterContent?.contact_us &&
        chapterContent.contact_us.replace(/(<([^>]+)>|\s)/g, '').trim() ? (
          <Col span={24}>
            <SectionLayout>
              <div className='Commitee-listing-sub-heading chapter-margin'>
                <p className='chapter-heading-underline'>
                  {ApplicationString['chapterPage.contactUs.title']}
                </p>
              </div>
              <span className='chapter-content-span'>
                {renderBenefits(chapterContent?.contact_us)}
              </span>
            </SectionLayout>
          </Col>
        ) : null}

        {allEventSponsorLogos?.length > 0 && (
          <Col span={24}>
            <SponsorListing
              sponsorData={allEventSponsorLogos}
              addScroll={true}
            />
          </Col>
        )}
      </Row>
    </React.Fragment>
  );
};
export default PbssChapterComponent;
